import { IconButtonGroup } from '@shared/IconButtonGroup'
import { Col, Row } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AsanIco, DeleteIco, EditIco } from '@modules/CustomIcons'
import { useWatch } from 'react-hook-form'
import useSelectedRowKey from '@shared/hooks/useSelectedRowKey'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { secureLocalStorageGet } from '../../../../../../app/helpers'
import { StatusType } from '../../constants/fieldValues.constant'
import { arrayBufferToBase64, AsanSigning } from '@shared/AsanSigning'
import { asanSigningAdocFile } from '../../../../../services/IbSigning/asan'
import useAsanAdocDownloader from '@shared/AsanSigning/useAsanAdocDownloader'
import {
  salaryCardListApi,
  useFetchSalaryCardListQuery,
  useFetchUpdateOrderStatusMutation,
} from 'store/reducers/salaryCards/salaryCardList.api'
import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'
import DeleteOrderForm from '../../entities/OrderDetailsModal/blocks/OrderDetailModalFooter/DeleteOrderForm'
import { IconButtonItemProps } from '@shared/IconButtonGroup/types'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

function SalaryCardFooterBar() {
  const { t } = useTranslation()
  const { downloadAdocFile } = useAsanAdocDownloader()
  const history = useHistory()
  const dispatch = useDispatch()

  const role = secureLocalStorageGet('rol')
  const status = useWatch({ name: 'status' })
  const selectedRowKeys = useSelectedRowKey()
  const originalArgs = useAppSelector(
    (state) => state.api.queries.fetchSalaryCardList?.originalArgs
  )
  const { data: salaryCardList } = useFetchSalaryCardListQuery(originalArgs, {
    skip: !originalArgs,
  })

  const [updateOrderStatus, { status: uosStatus, reset, isSuccess: isOsSuccess }] =
    useFetchUpdateOrderStatusMutation()

  const [fetchOrderDetails, { isSuccess, status: orderDetailStatus }] =
    useFetchOrderDetailsMutation({
      fixedCacheKey: 'fetchOrderDetails',
    })

  const disabledAdocAndFatcha = ![
    StatusType.CLOSED
  ].includes(
    salaryCardList?.orderList?.find(
      (item) => item.orderNo === selectedRowKeys.salaryCardTable?.[0]
    )?.status
  )

  const disabledSignBtn =
    salaryCardList?.orderList?.find(
      (item) => item.orderNo === selectedRowKeys.salaryCardTable?.[0]
    )?.status === StatusType.PENDING_SIGNER

  const disabledEditAndDeleteBtn = !(
    salaryCardList?.orderList?.find(
      (item) => item.orderNo === selectedRowKeys.salaryCardTable?.[0]
    )?.status === StatusType.PENDING_SIGNER
  )

  const downloadAdoc = async () => {
    downloadAdocFile(
      asanSigningAdocFile,
      salaryCardList?.orderList?.find(
        (item) => item.orderNo === selectedRowKeys.salaryCardTable?.[0]
      )?.transactionId,
      `${selectedRowKeys.salaryCardTable[0]}.adoc`
    )
  }

  const footerBtnsTransferFooter = [
    // {
    //   icon: <DownloadFatcaFile disabledCanditation={disabledAdocAndFatcha} />,
    //   title: t('orders.salaryCardOrder.constants.fatcaDownload'),
    //   key: 'adoc',
    //   visible: false,
    //   onClick: downloadFatcha,
    //   disabled: disabledAdocAndFatcha,
    // },
    {
      icon: <AsanIco />,
      title: t('transfers.downloadAdoc'),
      key: 'adoc',
      visible: false,
      onClick: downloadAdoc,
      disabled: disabledAdocAndFatcha,
    },
  ]

  const footerActionBtns: IconButtonItemProps[] = [
    {
      key: 'edit',
      icon: <EditIco />,
      title: t('transfers.edit2'),
      // modal: {
      //   status: isSuccess ? '' : orderDetailStatus,
      //   title: `${selectedRowKeys?.salaryCardTable?.[0]}`,
      //   centered: true,
      //   width: '100%',
      //   bodyStyle: {
      //     minHeight: '80vh',
      //     justifyContent: 'space-between',
      //     display: 'flex',
      //     flexDirection: 'column',
      //     padding: 0,
      //   },
      //   modalContent: <UpdateEmployeeForm />,
      // },
      visible: false,
      onClick: () => {
        history.push(
          `/orders/salary-card/update/${selectedRowKeys.salaryCardTable?.[0]}`
        )
        // fetchOrderDetails({
        //   orderNo: selectedRowKeys.salaryCardTable?.[0] as string,
        // })
      },
      disabled: disabledEditAndDeleteBtn,
    },
    {
      key: 'delete',
      icon: <DeleteIco />,
      title: t('transfers.delete'),
      modal: {
        footer: null,
        title: t('orders.salaryCardOrder.constants.deleteReason'),
        width: 600,
        bodyStyle: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' },
        modalContent: (
          <DeleteOrderForm
            orderNo={selectedRowKeys.salaryCardTable?.[0] as string}
          />
        ),
      },
      visible: false,
      onClick: () => {},
      disabled: disabledEditAndDeleteBtn,
    },
  ]

  const onSigning = async () => {
    if (selectedRowKeys?.salaryCardTable?.[0]) {
      const detailData = await fetchOrderDetails({
        orderNo: selectedRowKeys?.salaryCardTable?.[0],
      }).unwrap()

      return {
        files: [
          {
            name: `${selectedRowKeys.salaryCardTable[0]}.json`,
            mimeType: 'application/json',
            encodedBytes: arrayBufferToBase64(detailData),
          },
        ],
      }
    }
  }

  return (
    <>
      <Row align={'middle'}>
        <Col span={8}>
          {role === 2 && status === StatusType.FOR_MUST_BE_SIGNED && (
            <AsanSigning
              docType="SCO"
              asanKey="asanSignOutDetail"
              handleSigning={onSigning}
              checkSignCallback={() => disabledSignBtn}
              status={uosStatus}
              afterCloseFn={() => {
                if(isOsSuccess) {
                  dispatch(salaryCardListApi.util.invalidateTags(['SalaryCardStatusList', 'SalaryCardList']))
                  reset()
                }
              }}
              onComplete={(data) => {
                updateOrderStatus({
                  orderNo: selectedRowKeys.salaryCardTable?.[0],
                  ...data,
                })
              }}
            />
          )}
        </Col>
        <Col span={8} offset={8}>
          <Row justify="end" style={{ gap: 20 }}>
            <IconButtonGroup buttons={footerActionBtns} />
            <IconButtonGroup buttons={footerBtnsTransferFooter} />
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default SalaryCardFooterBar
